import './Grid.css';
// import 'primereact/resources/primereact.min.css';
// import 'primeicons/primeicons.css';
// import 'primeflex/primeflex.min.css';
// import "primereact/resources/primereact.min.css";
// import "primereact/resources/themes/saga-blue/theme.css";
import { Accordion, AccordionTab } from 'primereact/accordion';
import isEmpty from "lodash/isEmpty";
const Grid = (props) => {
    // console.log("props", props);

    let items;
    const myHeader = (title) => {
        return <>
            <div className="headerTitle">{CreateDicLanguages().nameOfOrganization} </div>
            <div className="headerText">{isEmpty(title) ? "" : title}</div>
        </>
    }

    const CreateDicLanguages = () =>{
        var dic ={};
        
        dic.he={};
        dic.ar={};
        dic.en={};

        dic.he["nameOfOrganization"]="שם הארגון";
        dic.he["affiliation"]="שיוך";
        dic.he["hosting"]="שרת מארח";
        dic.he["currentCampaign"]="קמפיין נוכחי";
        dic.he["currentCampaigns"]="קמפיין נוכחי";
        dic.he["branches"]="מטה / סניף";
        dic.he["linkToDesignation"]="קישור ליעד";
        dic.he["financialID"]="מזהה כספי";
        
        dic.ar["nameOfOrganization"]="Name of Organization";
        dic.ar["affiliation"]="Affiliation";
        dic.ar["hosting"]="Hosting";
        dic.ar["currentCampaign"]="Current Campaign";
        dic.ar["currentCampaigns"]="Current Campaigns";
        dic.ar["branches"]="HQ , Branches";
        dic.ar["linkToDesignation"]="Link to Designation";
        dic.ar["financialID"]="Financial ID";
       
        dic.en["nameOfOrganization"]="Name of Organization";
        dic.en["affiliation"]="Affiliation";
        dic.en["hosting"]="Hosting";
        dic.en["currentCampaign"]="Current Campaign";
        dic.en["currentCampaigns"]="Current Campaigns";
        dic.en["branches"]="HQ , Branches";
        dic.en["linkToDesignation"]="Link to Designation";
        dic.en["financialID"]="Financial ID";
        

                
        if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/he')> -1)
        {
          return dic.he;
        }
        else if(_spPageContextInfo.webServerRelativeUrl.toLowerCase().indexOf('/ar')> -1){
          return dic.ar;
        }
        else{
            return dic.en;
          }
      }

    items = props.items.map((item, index) => {

        return <AccordionTab header={myHeader(item.nameOfOrganization)} key={index}>
            <ul aria-label={item.nameOfOrganization} >
                {/* <li aria-label="Name of Organization">{item.nameOfOrganization}</li> */}
                {isEmpty(item.affiliation) ? "" : <li aria-label={CreateDicLanguages().affiliation}><p>{item.affiliation}</p></li>}
                {isEmpty(item.hosting) ? "" : <li aria-label={CreateDicLanguages().hosting}><p>{item.hosting}</p></li>}
                {/* {isEmpty(item.currentCampaign) ? "" : <li aria-label={CreateDicLanguages().currentCampaign}><p><a href={item.currentCampaign.NavigateUrl} >{item.currentCampaign.Text}</a></p></li>} */}
                {isEmpty(item.currentCampaigns) ? "" : <li aria-label={CreateDicLanguages().currentCampaigns}><p dangerouslySetInnerHTML={{__html:item.currentCampaigns}}></p></li>}
                {isEmpty(item.branches) ? "" : <li aria-label={CreateDicLanguages().branches}><p>{item.branches}</p></li>}
                {isEmpty(item.linkToDesignation) ? "" : <li aria-label={CreateDicLanguages().linkToDesignation}><p><a href={item.linkToDesignation.NavigateUrl} >{item.linkToDesignation.Text}</a></p></li>}
                {isEmpty(item.financialID) ? "" : <li aria-label={CreateDicLanguages().financialID}><p className="modNote">{item.financialID}</p></li>}
            </ul>
        </AccordionTab>
    });

    return (

        <div className="modGrid">
            <h2 className="gridHeader">{props.title}</h2>
            <div className="modAccordion">
                <Accordion multiple>
                    {items}
                </Accordion>
            </div>
        </div>
    )



}
export default Grid;

